var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDebrisDump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    id: "svg43036",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs43040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    fill: "none",
    id: "g43034",
    transform: "matrix(1.3768503,0,0,1.3768503,-6.0466077,-6.165434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.35,
    y: 25.15,
    width: 2.75,
    height: 1.3,
    rx: 0.30000001,
    id: "rect43020"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.049999,
    y: 25.15,
    width: 2.75,
    height: 1.3,
    rx: 0.30000001,
    id: "rect43022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.55,11.85 0.8,12.7 q 0,0.65 0.65,0.65 h 10 q 0.65,0 0.65,-0.65 l 0.8,-12.7",
    id: "path43024"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.6499996,
    y: 9.75,
    width: 14.7,
    height: 2,
    rx: 0.2,
    id: "rect43026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.9,9.75 2.55,-3.6 h 9.1 l 2.55,3.6",
    id: "path43028"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.75,
    y1: 8.75,
    x2: 13.65,
    y2: 6.1500001,
    id: "line43030"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.25,
    y1: 8.75,
    x2: 18.35,
    y2: 6.1500001,
    id: "line43032"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebrisDump);
export default __webpack_public_path__ + "static/media/debris_dump.f545d76ae9a5a2038f3b8853d0fce936.svg";
export { ForwardRef as ReactComponent };